import { Card, Divider, Grid } from '@material-ui/core'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getProjectRequestsDetails } from '../../../actions/projectActions'
import Loader from '../../Loader/Loader'

const OrderSummary = ({ charge }) => {
  const dispatch = useDispatch()

  const { loading: loadingRequests, projectRequests } = useSelector(
    (state) => state.projectRequestsDetails
  )
  const { project } = useSelector((state) => state.projectDetails)

  useEffect(() => {
    if (project._id) {
      dispatch(getProjectRequestsDetails(project._id))
    }
  }, [project, dispatch])

  return (
    <>
      <h2 className="m-b-24 fs20">Order summary</h2>
      <Card className="p-16">
        <div style={{ position: 'relative' }}>
          {loadingRequests && <Loader />}
          {projectRequests !== undefined &&
            projectRequests.map((request, index) => (
              <div key={index} className="fs14">
                <span className="bold">{request.name}</span>{' '}
                <span className="fs12 gray"> Contract {request.type}</span>
              </div>
            ))}

          {project.addOnServices.onsiteDebugging && (
            <div className="fs14">
              <span className="bold">Onsite debugging</span>
            </div>
          )}
          {project.addOnServices.correlationGRR && (
            <div className="fs14">
              <span className="bold">Correlation GR+R</span>
            </div>
          )}
          {project.addOnServices.fixtureDesign && (
            <div className="fs14">
              <span className="bold">Fixture design</span>
            </div>
          )}
          {project.addOnServices.premiumSupport && (
            <div className="fs14">
              <span className="bold">Premium support</span>
            </div>
          )}
          {project.addOnServices.classroomOrVirtualSupport && (
            <div className="fs14">
              <span className="bold">Classroom or virtual support</span>
            </div>
          )}
          {project.addOnServices.customOnsiteTraining && (
            <div className="fs14">
              <span className="bold">Custom onsite training</span>
            </div>
          )}
        </div>
        <Divider className="m-t-24 m-b-24" />

        <div className="flex space-between">
          <h5 className="m-b-0">
            {project.charges.length > 1 ? 'Additional charge' : 'Total'}
          </h5>
          <h5 className="m-b-0">{`$${Number(
            charge.toFixed(2)
          ).toLocaleString()}`}</h5>
        </div>
      </Card>
      <h2 className="m-b-24 m-t-40">Contact information</h2>
      <Card className="p-16 gray">
        <Grid container spacing={1} className="fs14">
          <Grid item xs={12}>
            <strong>{project.userName}</strong>
          </Grid>
          <Grid item xs={4} className="gray-text">
            Shipping address
          </Grid>
          <Grid item xs={8}>
            {project.shippingAddress && (
              <>
                {project.shippingAddress.streetAddress}
                <br />
                {project.shippingAddress.aptSuiteOther && (
                  <>
                    {project.shippingAddress.aptSuiteOther} <br />
                  </>
                )}
                {project.shippingAddress.city}, {project.shippingAddress.state}{' '}
                {project.shippingAddress.zipCode}
              </>
            )}
          </Grid>
          <Grid item xs={4} className="gray-text">
            Phone
          </Grid>
          <Grid item xs={8}>
            {project.userPhone && project.userPhone}
          </Grid>
          <Grid item xs={4} className="gray-text">
            Email
          </Grid>
          <Grid item xs={8} className="truncate">
            {project.userEmail}
          </Grid>
        </Grid>
      </Card>
    </>
  )
}

export default OrderSummary
